import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class SectionTypeRepository<SectionTypeModel> extends RepositoryBase<SectionTypeModel> {
    public constructor() {
        super('sectionType');
    }
}
